import { Injectable } from '@angular/core';
import { RestService } from '../services/rest.service';

@Injectable({
  providedIn: 'root'
})
export class TagService {

  constructor(private restHttp: RestService) { }

  addTag(model) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/RestaurantTag`, model);
  }
}
